import { colors } from '../styles/tokens'

export function Button({ variant = 'primary', size = 'md', disabled, children, ...props }) {
  const sizes = {
    sm: { padding: '5px 10px', fontSize: 13 },
    md: { padding: '8px 16px', fontSize: 14 },
  }
  const variants = {
    primary: {
      background: disabled ? '#9CA3AF' : colors.primary,
      color: '#fff',
      border: 'none',
    },
    secondary: {
      background: '#fff',
      color: colors.textPrimary,
      border: `1px solid ${colors.borderStrong}`,
    },
    ghost: {
      background: 'transparent',
      color: colors.primary,
      border: 'none',
      padding: 0,
    },
  }

  return (
    <button
      disabled={disabled}
      style={{
        ...sizes[size],
        ...variants[variant],
        borderRadius: 6,
        fontWeight: 600,
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontFamily: 'inherit',
        transition: 'background 0.15s ease',
      }}
      {...props}
    >
      {children}
    </button>
  )
}

export function Input(props) {
  return (
    <input
      {...props}
      style={{
        padding: '8px 10px',
        borderRadius: 6,
        border: `1px solid ${colors.borderStrong}`,
        fontSize: 14,
        fontFamily: 'inherit',
        color: colors.textPrimary,
        ...props.style,
      }}
    />
  )
}

export function Select(props) {
  return (
    <select
      {...props}
      style={{
        padding: '8px 10px',
        borderRadius: 6,
        border: `1px solid ${colors.borderStrong}`,
        fontSize: 14,
        fontFamily: 'inherit',
        color: colors.textPrimary,
        background: '#fff',
        ...props.style,
      }}
    >
      {props.children}
    </select>
  )
}

export function Checkbox({ label, ...props }) {
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: colors.textSecondary, cursor: 'pointer' }}>
      <input type="checkbox" {...props} />
      {label}
    </label>
  )
}
